import cards from "./cards";

export default {
    cards,
};
